<div class="document-preview" *transloco="let t">
  <div class="modal-header document-preview-header">
    <h5 class="modal-title text-truncate" [title]="fileName">{{ fileName }}</h5>
    <div class="document-preview-actions">
      <button type="button" class="btn btn-outline-primary btn-icon btn-rounded" (click)="download()">
        <i class="material-symbols-rounded">download</i> {{ t('documentPreview/download') }}
      </button>
      <button *ngIf="canPrint" type="button" class="btn btn-outline-primary btn-icon btn-rounded" (click)="print()">
        <i class="material-symbols-rounded">print</i> {{ t('documentPreview/print') }}
      </button>
      <button type="button" class="btn btn-outline-primary btn-icon btn-rounded" (click)="close()">
        <i class="material-symbols-rounded">close</i> {{ t('documentPreview/close') }}
      </button>
    </div>
  </div>

  <div class="modal-body document-preview-body">
    <div *ngIf="loading" class="document-preview-message">
      <div class="spinner-border text-primary" role="status"></div>
      <p>{{ t('documentPreview/loading') }}</p>
    </div>

    <ng-container *ngIf="!loading">
      <iframe
        *ngIf="kind === 'pdf' && previewUrl"
        #pdfFrame
        class="document-preview-frame"
        [title]="fileName"
        [src]="previewUrl | safe: 'resourceUrl'"
      ></iframe>

      <img *ngIf="kind === 'image' && previewUrl" class="document-preview-image" [alt]="fileName" [src]="previewUrl | safe: 'url'" />

      <div *ngIf="kind === 'unsupported'" class="document-preview-message">
        <span class="material-symbols-rounded document-preview-icon">description</span>
        <p>{{ t('documentPreview/unsupported') }}</p>
        <button type="button" class="btn btn-primary btn-icon btn-rounded" (click)="download()">
          <i class="material-symbols-rounded">download</i> {{ t('documentPreview/download') }}
        </button>
      </div>
    </ng-container>
  </div>
</div>
